<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="1200px"
            transition="false"

        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("savedСalculations") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-progress-linear color="green" :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

                <v-card-text class="pa-0">
                    <v-toolbar card prominent dense>
                        <v-btn
                            flat
                            @click="reload"
                        >
                            <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                        </v-btn>
                        <v-btn
                            flat
                            @click="loadTaskClick"
                            :disabled="!selectedRow"
                        >
                            <v-icon>mdi-open-in-app</v-icon> {{ $t("open") }}
                        </v-btn>
                        <v-btn
                            flat
                            @click="deleteItemClick(selectedRow)"
                            :disabled="!selectedRow"
                        >
                            <v-icon>mdi-delete-outline</v-icon> {{ $t("delete") }}
                        </v-btn>
                    </v-toolbar>

                    <v-layout row>
                        <v-select
                            v-model="selectedContract"
                            :items="contracts"
                            item-text="Name"
                            item-value="id"
                            :label="`${$t('contract')}`"
                            required
                            hide-details
                            style="max-width: 250px;"
                            class="ml-3 mr-2"
                            >
                        </v-select>
                        <v-select
                            v-model="selectedSpecies"
                            :items="species"
                            item-text="Name"
                            item-value="id"
                            :label="`${$t('speciesAlt')}`"
                            required
                            hide-details
                            style="max-width: 200px;"
                            class="ml-2 mr-3"
                            >
                        </v-select>
                    </v-layout>

                    <v-data-table
                        hide-actions
                        :headers="computedHeaders"
                        :items="filteredTasks"
                        class="dense-table ma-3 tasks-table"
                    >
                        <template v-slot:items="props">
                            <tr
                                @click="selectedRow = props.item"
                                @dblclick="loadTaskClick"
                                :class="{'grey darken-5': props.item === selectedRow}"
                            >
                                <td class="text-xs-center ">
                                    <v-layout align-center justify-center>
                                        <v-icon small class="mr-1" color="success">mdi-invoice-list-outline</v-icon>
                                        <span class="font-weight-bold">{{ props.item.Contract.Num }}</span>
                                    </v-layout>
                                    <v-layout align-center justify-center>
                                        <span class="caption">{{ props.item.Contract.Name }}</span>
                                    </v-layout>
                                </td>
                                <td class="text-xs-center">{{ $t(props.item.Species.Name) }}</td>
                                <td class="text-xs-center">
                                    {{ props.item.Name }}
                                </td>
                                <td class="text-xs-center">
                                    <p class="caption">{{ props.item.Comment }}</p>
                                </td>
                                <td class="text-xs-center">{{ props.item.modDate }}</td>
                            </tr>
                        </template>
                        <!--
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{ $t("youSearchFor") }}{{ lengthsSearch }}{{ $t("foundNoResults") }}.
                            </v-alert>
                        </template>
                        -->
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="loadTaskClick" :disabled="!selectedRow">{{ $t("open") }}</v-btn>
                    <v-btn color="error" @click="cancelClick">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
        <message-dialog ref="MessageDialog"/>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";
    import MessageDialog from "@/components/dialogs/MessageDialog";

    export default {
        name: "SavedCalculationsDialog",

        components: {
            MessageBox,
            MessageDialog
        },

        data () {
            return {
                dialog: false,

                dataLoaded:         [],
                events:             [],
                id:                 null,
                locale:             "en-us",
                progressBarVisible: false,
                tasks:              [],
                selectedRow:        null,
                species:            [],
                selectedSpecies:    null,
                contracts:          [],
                selectedContract:   null,
                dialogWatcher:      null,
                loadTask:           false,

                hideIDs: true,
                headers: [
                    { text: "id",       value: "id",     align: "center", sortable: true },
                    { text: "Заказ",    value: "contract",    align: "center",   sortable: false },
                    { text: "Порода",   value: "species",    align: "center",   sortable: false },
                    { text: "Имя",      value: "name",    align: "center",   sortable: false },
                    { text: "Комментарий",   value: "comment",    align: "center",   sortable: false},
                    { text: "Дата",   value: "modDate",    align: "center",   sortable: false },
                ],
            }
        },

        computed: {
            filteredTasks () {
                return this.tasks.filter(t => (t.ContractId == this.selectedContract && (this.selectedSpecies == 0 || t.SpeciesId == this.selectedSpecies)));
            },

            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },
        },

        watch: {
            async dialog (val) {
                if (val) {
                    await this.loadContracts();
                    await this.loadSpecies();

                    this.selectedSpecies = this.species.length > 0 ? this.species[0].id : null;
                    this.selectedContract = this.contracts.length > 0 ? this.contracts[0].id : null;

                    this.loadTasks();
                }
            }
        },

        async mounted () {
            this.applyLocale();

            // await this.loadContracts();
            // await this.loadSpecies();

            // this.selectedSpecies = this.species.length > 0 ? this.species[0].id : null;
            // this.selectedContract = this.contracts.length > 0 ? this.contracts[0].id : null;

            // this.loadTasks();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",       value: "id",     align: "center", sortable: true },
                    { text: this.$t("contract"),            value: "contract",    align: "center",   sortable: false, width: "150px" },
                    { text: this.$t("speciesAlt"),          value: "species",    align: "center",   sortable: false, width: "150px" },
                    { text: this.$t("name"),                value: "name",    align: "center",   sortable: false },
                    { text: this.$t("comment"),             value: "comment",    align: "center",   sortable: false, width: "300px" },
                    { text: this.$t("createModifyDate"),    value: "modDate",    align: "center",   sortable: false },
                ];
            },

            /**
             * Загрузка задач
             */
            loadTasks () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}tasks/saved/`, { withCredentials: true })
                    .then(response => {
                        this.progressBarVisible = false;

                        if (response.data.status == "success") {
                            this.tasks = response.data.tasks;

                            this.tasks.forEach((task) => {
                                task.modDate = new Date(task.updatedAt);
                                task.modDate = `${task.modDate.toLocaleDateString()} ${task.modDate.toLocaleTimeString()}`
                            })
                        }
                    })
                    .catch(err => {
                        this.progressBarVisible = false;

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadTasksData"));

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `TasksHistoryDialog.vue -> getTasks: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Загрузка заказов
             */
             loadContracts () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}contracts/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {

                            this.contracts = response.data.contracts;

                            if (this.selectedContract == null) {
                                this.selectedContract = this.contracts.length > 0 ? this.contracts[0].id : null;
                            }
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData"));
                        }
                    });
            },

            /**
             * Загрузка списка пород
             */
             loadSpecies () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            this.species = response.data.species;

                            this.species.unshift({ id: 0, Name: this.$t("all") });

                            this.species.forEach((species) => {
                                species.Name = this.$t(species.Name);
                            })

                            if (this.selectedSpecies == null) {
                                this.selectedSpecies = this.species.length > 0 ? this.species[0].id : null;
                            }

                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.$refs.MessageBox.title       = this.$t("error");
                            this.$refs.MessageBox.messageText = this.$t("sessionExpired");
                            this.$refs.MessageBox.dialog      = true;

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Удаление элемента
             *
             * @param {object} item Информация об удаляемом элементе
             */
             deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}tasks/saved/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.reload();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDelete") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDelete") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDelete"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления длины
             *
             * @param {object} item Информация об удаляемом элементе
             */
            deleteItemClick (item) {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("calculationDelete");
                this.$refs.MessageDialog.messageText = `${this.$t("confirmCalculationDelete")} (${item.Name})`;
                this.$refs.MessageDialog.dialog      = true;
            },

            async reload () {
                this.selectedRow = null;

                await this.loadContracts();
                await this.loadSpecies();

                this.loadTasks();
            },

            loadTaskClick () {
                this.loadTask = true;
                this.dialog   = false;
            },

            cancelClick () {
                this.loadTask = false;
                this.dialog   = false;
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .tasks-table
        border: 1px solid #e0e0e0
        border-radius: 4px
        overflow-y: auto
        height: 400px
</style>
